import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { API_BASE_URL, RECAPTCHA_SITE_KEY } from "@utils/constant";
import { SubmitHandler, useForm } from "react-hook-form";
import { Fade } from "react-awesome-reveal";
import ThankYou from "@pages/contact/parts/thank-you";
import { triggerEachFormTracker } from "@utils/helper";

const SectionOne: React.FC<any> = ({ sectionRef }) => {
  const params = new URLSearchParams(window.location.search);
  // export const SectionOne = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const recaptchaRef = React.useRef<ReCAPTCHA>();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    brand_url: "",
    g_recaptcha_token: "",
    form_type: ""
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { handleSubmit, getValues } = useForm({});

  // const { data, params } = props;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Allow only + and digits in mobile
    if (name === "mobile" && /[^\d+]/.test(value)) return;

    if (name === "daily_order") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        sub_platform: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!formData.name.trim())
      newErrors.name = "Full name is required.";

    if (!formData.mobile.trim())
      newErrors.mobile = "Phone number is required.";
    else if (!/^\+?\d{7,15}$/.test(formData.mobile.trim()))
      newErrors.mobile = "Enter a valid Phone number.";

    if (!formData.email.trim()) newErrors.email = "Email Id is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email id.";

    if (!formData.brand_url.trim()) {
      newErrors.brand_url = "Ecommerce Store Link is required.";
    }




    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleRecaptchaChange = (value) => {
    formData.g_recaptcha_token = value;
    formData.form_type = 'Checkout V2'
    // formData.daily_order = getValues("daily_order");
    // formData.sub_platform = getValues("sub_platform");
    axios
      .post(API_BASE_URL + "form/shopify/checkv1", formData)
      .then(function (response) {
        setSuccessMessage("Demo booked successfully!");
        triggerEachFormTracker(formData)
        setFormData({
          name: formData.name,
          mobile: "",
          email: "",
          brand_url: "",
          g_recaptcha_token: "",
          form_type: ""
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error.response.data?.errors["product[]"]);
        setErrors(error?.response?.data?.errors);
      });
  };

  const handleRecaptchaSubmit = async () => {
    // Trigger the reCAPTCHA challenge
    recaptchaRef.current.execute();
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    // if (!data.product) {
    //   data.product = [];
    // }
    setSuccessMessage("");
    if (!validateForm()) return;

    data.source = params.get("utm_source");
    data.medium = params.get("utm_medium");
    data.campaign = params.get("utm_campaign");

    data.campaignid = params.get("campaignid");
    data.adgroupid = params.get("adgroupid");
    data.keyword = params.get("keyword");
    data.utm_term = params.get("utm_term");
    data.gad_source = params.get("gad_source");
    data.gad_campaignid = params.get("gad_campaignid");
    data.gbraid = params.get("gbraid");
    data.gclid = params.get("gclid");
    setFormData(prevData => ({
      ...prevData,
      ...data
    }));
    handleRecaptchaSubmit();
  };


  return (
    <div className="sectionke-Ind section-checkout-2" style={{minHeight :isMobile ?"80vh": "90vh"}}>
      <div className="container-fluid">
        <div className="row banner align-items-center" >
          <div className="col-lg-6 col-md-12 banner-left" style={{ marginLeft: isMobile ? '0.2rem' : "5rem" }}>
            <div className="heading-Ind1">
              <h1 style={{ fontWeight: "600", fontSize: "clamp(38px, 6vw, 47px)",maxWidth: '631px'}}>
                  "We saw <span style={{color:"#0012b7"}}>25% higher revenue</span>  and 38.41% GMV boost with KwikCheckout"
              </h1>
      <div className="secthree-cc--founder-info">
                <img
                  src='/assets/images/custom-checkout/mac-founder.png'
                  alt="Vaishali Gupta"
                  className="secthree-cc--founder-img"
                />
                <div className="secthree-cc--founder-text">
                  <p className="secthree-cc--founder-name"style={{color:'black'}}>Vaishali Gupta,</p>
                  <p className="secthree-cc--company-name" style={{color:'black'}}>Co-founder, mCaffeine</p>
                </div>
              </div>

            </div>
          </div>

          <div className="col-lg-5 col-md-12 banner-right mt-4 mt-lg-0" ref={sectionRef}>
            <div style={{ marginLeft: "50px" }}>
              <div className="form-wrapper1-Ind" style={{ width: isMobile ? "90%" : "95%" }}>
                <div className="form-container1-Ind">
                  {successMessage && (
                    <Fade direction="right">
                      <ThankYou name={formData?.name} />
                    </Fade>
                  )}
                  {
                    !successMessage &&
                    <form
                      className="demo-form1-Ind"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                    >

                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Full Name"
                      />
                      {errors.name && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.name}
                        </p>
                      )}

                      <input
                        type="tel"
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Phone Number"
                      />
                      {errors.mobile && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.mobile}
                        </p>
                      )}

                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Email Id"
                      />
                      {errors.email && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.email}
                        </p>
                      )}

                      <input
                        type="url"
                        id="brand_url"
                        name="brand_url"
                        value={formData.brand_url}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Ecommerce Store link"
                      />
                      {errors.brand_url && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.brand_url}
                        </p>
                      )}

                      {/* <select
                        id="daily_order"
                        name="daily_order"
                        // value={formData.daily_order}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        // placeholder="Montly Orders"
                      >
                        <option value="" style={{ color: "#333", }}>Daily Orders</option>
                        {platformOptions.map((opt) => (
                          <option key={opt.name} value={opt.name}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                      {errors.daily_order && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.daily_order}
                        </p>
                      )} */}


                      {/* <input
                        type="number"
                        id="no_of_transaction"
                        name="no_of_transaction"
                        value={formData.no_of_transaction}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Montly Orders"
                      />
                      {errors.name && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.no_of_transaction}
                        </p>
                      )} */}

                      <ReCAPTCHA
                        ref={recaptchaRef as React.RefObject<ReCAPTCHA>}
                        sitekey={RECAPTCHA_SITE_KEY}
                        size="invisible"
                        onChange={handleRecaptchaChange}
                      />

                      <button type="submit" disabled={loading} style={{ borderRadius: "5px" }}>
                        {loading ? "Submitting..." : "Book a Demo"}
                      </button>

                      {successMessage && (
                        <p className="success">{successMessage}</p>
                      )}
                      <p style={{color:"grey",textAlign:'center'}}>we'll get back within 24 hrs</p>
                    </form>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
}
export default SectionOne